import { combineReducers } from 'redux';
import list from './list';
import create from './create';
import update from './update';
import currentSiteSettings from './currentSiteSettings';
import accept from './accept';

export default combineReducers({list, create, update, currentSiteSettings, accept });
